<template>
  <div>
    <div v-if="documents.length > 0">
      <table class="custom-table table-hover">
        <thead>
          <tr>
            <th scope="col">Document</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="d in documents" :key="d.documentId" @click="open(d.url)">
            <td>
              {{d.name}}
              <!-- <span class="add">
            <b-button class="additional-btn kebab">
              <b-icon class="icon kebab" icon="three-dots-vertical" font-scale="1"></b-icon>
            </b-button>
          </span> -->
            </td>
          </tr>
        </tbody>
      </table>
      <!-- <div  v-for="d in documents" :key="d.documentId" class="item">
        <p>
          <a :href="d.url" target="_blank">{{d.name}}</a>
        </p>
      </div> -->
    </div> 
    <div v-else>
      Nothing to report
    </div>
  </div>
</template>

<script>
export default {
  props: {
    documents: { type: Array, default: () => [] }
  },
  methods: {
    open(url) {
      window.open(url, '_blank');
    }
  }
}

</script>
